@if (items().length) {
  <div class="unique-selling-point fill white-bg surface-primary">
    <div class="border-top">
      <div
        class="ups-container flex pr-medium-y"
        [class.flex--space-around]="!isNewBrand()"
        [class.grid-max-width]="!isNewBrand()"
        [class.center]="!isNewBrand()"
      >
        @for (item of items(); track $index) {
          <div
            class="usp-item nordic-blue-900-text text-icon-primary medium-type is-hidden"
            [class.flex-1]="isNewBrand()"
            [class.flex--basis0]="isNewBrand()"
            [class.align-left]="isNewBrand()"
            [innerHTML]="item.teaserText | finSafe: 'html'"
          ></div>
        }
      </div>
    </div>
  </div>
}
